import { IMarketplaceFilters } from 'utils/hooks/useMarketplaceParams'
import { ILoadFilters } from 'apps/fleet-planner/types/loads'

type TLoadFilter = keyof ILoadFilters

const DEFAULT_FILTERS: TLoadFilter[] = [
  'dropoffDate',
  'dropoffFacilityId',
  'dropoffLocality',
  'pickupDate',
  'pickupFacilityId',
  'pickupLocality',
  'referenceNumber',
]

/**
 * Returns number of keys with values in a filter object
 */
export const getFilterCount = (
  allFilters: Partial<ILoadFilters> = {},
  countedFilters: TLoadFilter[] = DEFAULT_FILTERS
): number => {
  let count = 0

  Object.entries(allFilters)
    .filter(([key]) => countedFilters.includes(key as keyof ILoadFilters))
    .forEach(([, val]) => {
      if (val) count += 1
    })

  return count
}

type TMarketplaceLoadFilter = keyof IMarketplaceFilters

const DEFAULT_MARKETPLACE_FILTERS: TMarketplaceLoadFilter[] = [
  'deliveryMiles',
  'pickupMiles',
  'equipment',
]

/**
 * Returns number of keys with values in a filter object
 */
export const getMarketplaceFilterCount = (
  allFilters: Partial<IMarketplaceFilters> = {},
  countedFilters: TMarketplaceLoadFilter[] = DEFAULT_MARKETPLACE_FILTERS
): number => {
  return Object.entries(allFilters).filter(
    ([key, val]) => countedFilters.includes(key as keyof IMarketplaceFilters) && val
  ).length
}
